import type { HistoricalDataPayload } from '../../../../../../api/rs-hg/risk/historicalData.types';

export interface IHistoricalTableData {
  [key: string]: string;
}

export const generateHistoricalTableColumns = (data: HistoricalDataPayload) => {
  if (!data.length) return [];

  try {
    return data[0].map((col: string) => ({
      field: col,
      title: col,
      cellStyle: {
        padding: '0.62rem',
      },
      headerStyle: {
        padding: '0.62rem',
      },
    }));
  } catch (err) {
    return err;
  }
};

export const generateHistoricalTableData = (
  data: HistoricalDataPayload,
): IHistoricalTableData[] => {
  if (data.length < 2) return [];

  const headers = data[0];

  return data.slice(1).map((datum) => {
    const tableRow: IHistoricalTableData = {};
    headers.forEach((param, innerIndex) => {
      tableRow[param] = datum[innerIndex];
    });
    return tableRow;
  });
};

export function generateHistoricalTimeSeriesData(
  inputData: HistoricalDataPayload,
) {
  if (!inputData.length) return [];

  return generateHistoricalTableData(inputData).map((el) => {
    const { Date: name, ...rest } = el;
    return { name, ...rest };
  });
}
